import { SelectCheckAllComponent } from './components/amd-select-check-all/amd-select-check-all.component';
/**
 * Created by francesco on 30/10/17.
 */
import { NgModule } from '@angular/core';
import { CommonModule, Location } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, RequestOptions, XHRBackend } from '@angular/http';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE, MatBadgeModule, MatBottomSheetModule, MatDatepickerModule, MatMenuModule, MatNativeDateModule, MatStepperModule} from '@angular/material';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatButtonModule } from '@angular/material/button';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { LoginRequestService } from './service/login-request.service';
import { HttpAuthService } from './service/http-auth.service';
import { Router, RouterModule } from '@angular/router';
import { HighLightPipe } from './pipes/highlight.pipe';
import { RemoveSpacesPipe } from './pipes/remove-spaces.pipe';
import { NumberFormatPipe } from './pipes/commadumper.pipe';
import { BreadcrumbComponent } from './components/breadcrumb/breadcrumb.component';
import { GeneralMessageDialogComponent } from './components/general-message-dialog/general-message-dialog.component';
import { HeaderComponent } from './components/header/header.component';
import { InnerMessagesComponent } from './components/inner-messages/inner-messages.component';
import { SelectCenterComponent } from './components/select-center/select-center.component';
import { AmdStickyComponent } from './components/amd-sticky/amd-sticky.component';
import { DragAndDropFileComponent } from './components/drag-and-drop-file/drag-and-drop-file.component';
import { SearchDialogComponent } from './components/search-dialog/search-dialog.component';
import { AddToHomeDialogComponent } from './components/add-to-home-dialog/add-to-home-dialog.component';
import { RemoveFileDialogComponent } from './components/remove-file-dialog/remove-file-dialog.component';
import { SafeHtmlPipe } from './pipes/safe-html-pipe';
import { CountoModule } from 'angular2-counto';
import { DpDatePickerModule } from 'ng2-date-picker';
import { DateCustomFormatPipe, DateOffsetUtcPipe, DateUtcPipe, DateUtcPipeLocale, DateCustomFormat } from './pipes/date-utc.pipe';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { ErrorPageComponent } from './components/error-page/error-page.component';
import { AutoCompleteComponent } from './components/autocomplete/autocomplete.component';
import { FormAccordionContainerComponent } from './components/amd-form-accordion-container/form-accordion-container.component';
import { CardComponent } from './components/amd-card/card.component';
import { ToolbarWidgetComponent } from './components/toolbar-widget/toolbar-widget.component';
import { AlertsWidgetComponent } from './components/alerts-widget/alerts-widget.component';
import { SimpleTableComponent } from './components/amd-simple-table/simple-table.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { FullScreenSimpleTableDialogComponent } from './components/amd-full-screen-simple-table-dialog/full-screen-simple-table-dialog.component';
import { AmdStepperComponent } from './components/amd-stepper/amd-stepper.component';
import { CapitalizeFirstLetterPipe } from '@shared/pipes/capitalize-first-letter.pipe';
import { SpaceDumperPipe } from '@shared/pipes/space-dumper.pipe';
import { TagItemComponent } from './components/tag-item/tag-item.component';
import { AddAttachedDialogComponent } from './components/add-attached-dialog/add-attached-dialog.component';
import { TimeFromNowPipe } from './pipes/time-from-now.pipe';
import { FileSizePipe } from './pipes/file-size.pipe';
import { NotificationItemComponent } from './components/notification-item/notification-item.component';
import { DownloadListComponent } from './components/download-list/download-list.component';
import { ItemsCounterComponent } from './components/items-counter/items-counter.component';
import { InfiniteScrollerDirective } from './components/infinite-scroller/infinite-scroller.directive';
import { ChipsComponent } from './components/chips/chips.component';
import { NotFoundPageComponent } from './components/not-found-page/not-found-page.component';
import { DeviceDetectorModule } from 'ngx-device-detector';
import { APP_MOMENT_DATE_FORMATS } from '../date.adapter';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { HeaderDetailsComponent } from '@shared/components/header-details/header-details.component';
import { CalendarHeaderComponent } from './components/calendar-header/calendar-header.component';
import { PrintButtonComponent } from './components/print-button/print-button.component';
import { PdfViewerComponent } from 'ng2-pdf-viewer/dist/pdf-viewer.component';
import { AttachFileComponent } from './components/attach-file/attach-file.component';
import { IncludeTemplateComponent } from './components/include-template/include-template.component';
import { FindCenterComponent } from './components/find-center/find-center.component';
import { ReportButtonComponent } from './components/report-button/report-button.component';
import { AppConfigEnvironmentService } from '@shared/service/appconfig-environment.service';
import { CurrencyMaskModule } from 'ng2-currency-mask';
import { CURRENCY_MASK_CONFIG, CurrencyMaskConfig } from 'ng2-currency-mask/src/currency-mask.config';
import { CcSelectDataForAppointmentTableComponent } from '@shared/components/cc-select-data-for-appointment-table/cc-select-data-for-appointment-table.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { CcSelectCenterForAppointmentComponent } from '@shared/components/cc-select-center-for-appointment/cc-select-center-for-appointment.component';
import { CcCenterListForAppointmentComponent } from '@shared/components/cc-center-list-for-appointment/cc-center-list-for-appointment.component';
import { TranslatePipe } from '@shared/pipes/translate.pipe';
import { GenericViewAttachmentPreviewDialogComponent } from './components/view-files/components/generic-view-attachment-preview-dialog/generic-view-attachment-preview-dialog.component';
import { GenericViewAttachmentsComponent } from '@shared/components/view-files/components/generic-view-attachments/generic-view-attachments.component';
import { GenericViewAttachmentItemComponent } from '@shared/components/view-files/components/generic-view-attachment-item/generic-view-attachment-item.component';
import { GenericViewAttachmentUploadComponent } from './components/view-files/components/generic-view-attachment-upload/generic-view-attachment-upload.component';
import { InPageMessageComponent } from './components/in-page-message/in-page-message.component';
import { MaxNumberGrantedDirective } from './directives/max-number-granted/max-number-granted.directive';
import { TyresMatChipStatusComponent } from '@shared/components/tyres-mat-chip-status/tyres-mat-chip-status.component';
import { TireImpactPointComponent } from '@shared/components/tire-impact-point/tire-impact-point.component';
import { InternalImpactPointModule } from '@shared/components/internal-impact-point/internal-impact-point.module';
import { ExternalImpactPointComponent } from '@shared/components/external-impact-point/external-impact-point.component';
import { KeysPipe } from './pipes/keys.pipe';
import { SuffixPipe } from '@shared/pipes/suffix.pipe';
import { PrefixPipe } from '@shared/pipes/prefix.pipe';
import { VersionComponent } from './components/version/version.component';
import { CoreSignComponent } from '@shared/components/core-sign/core-sign.component';
import { FormattedNumberPipe } from '@shared/pipes/number.pipe';
import { SignStepperComponent } from '@shared/components/core-sign/components/sign-stepper/sign-stepper.component';
import { WarningDialogComponent } from '@shared/components/warning-dialog/warning-dialog.component';
import { MatDatepickerValidDateDirective } from './directives/mat-datepicker-valid-date.directive';
import { MessageManagerComponent } from './components/message-manager/message-manager.component';
import { MessageManagerService } from '@shared/service/message-manager/message-manager.service';
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { MatSelectResponsivePanelDirective } from '@shared/directives/mat-select-responsive-panel.directive';
import { ConfirmActionDialogComponent } from 'app/administration/administration-shared/components/confirm-action-dialog/confirm-action-dialog.component';
import { FindCentersComponent } from '@shared/components/find-centers/find-centers.component';
import { NoSpaceInputDirective } from '@shared/directives/no-space-input.directive';
import { MapsAPILoader, AgmCoreModule, GoogleMapsAPIWrapper } from '@agm/core';
import { AdministrationPanelComponent } from './components/administration-pannel/administration-panel.component';
import { AdministrationPanelItemComponent } from './components/administration-pannel/administration-panel-item/administration-panel-item.component';
import { DigitalSignProcedureComponent } from './components/core-sign/components/digital-sign-procedure/digital-sign-procedure.component';
import { DigitalSignOperatorProcedureStartComponent } from './components/core-sign/components/digital-sign-procedure/digital-sign-operator-procedure/digital-sign-operator-procedure-start/digital-sign-operator-procedure-start.component';
import { DigitalSignOperatorProcedureEndComponent } from './components/core-sign/components/digital-sign-procedure/digital-sign-operator-procedure/digital-sign-operator-procedure-end/digital-sign-operator-procedure-end.component';
import { DigitalSignCustomerProcedureStartComponent } from './components/core-sign/components/digital-sign-procedure/digital-sign-customer-procedure/digital-sign-customer-procedure-start/digital-sign-customer-procedure-start.component';
import { DigitalSignCustomerProcedureEndComponent } from './components/core-sign/components/digital-sign-procedure/digital-sign-customer-procedure/digital-sign-customer-procedure-end/digital-sign-customer-procedure-end.component';
import { SignOptionsComponent } from './components/core-sign/components/sign-options/sign-options.component';
import { DigitalSignContentFileDialogComponent } from './components/core-sign/components/digital-sign-procedure/digital-sign-content-file-dialog/digital-sign-content-file-dialog.component';
import { DigitalSignOtpDialogComponent } from './components/core-sign/components/digital-sign-procedure/digital-sign-otp-dialog/digital-sign-otp-dialog.component';
import { PaperSignMotivationDialogComponent } from './components/core-sign/components/paper-sign-motivation-dialog/paper-sign-motivation-dialog.component';
import { CoreSignAttachmentComponent } from './components/core-sign/components/core-sign-attachment/core-sign-attachment.component';
import {BookingCalendarComponent} from './components/booking-calendar/booking-calendar.component';
import { NotificationDialogComponent } from './components/notification-dialog/notification-dialog.component';
import { DateIntervalPipe } from './pipes/date-interval.pipe';
import { GeneralNotesComponent } from './components/general-notes/general-notes.component';
import { GeneralNoteDialogComponent } from './components/general-note-dialog/general-note-dialog.component';
import {QuillModule} from 'ngx-quill';
import {ConfirmActionComponent} from '@shared/components/confirm-action/confirm-action.component';
import { GeneralStepperComponent } from './components/general-stepper/general-stepper.component';
import { CommoditiesUtilityService } from './service/commodities-utility.service';
import { SelectCenterLocalComponent } from './components/select-center-local/select-center-local.component';
import { MultiCurrencyPipe } from './pipes/currency.pipe';
import { TableListButtonHeader } from '@shared/components/table-list-button-header/table-list-button-header.component';
import { DialogReadonlyComponent } from '@shared/components/dialog-readonly/dialog-readonly.component';
import { CenterListSelectComponent } from '@shared/components/center-list-select/center-list-select.component';
import { AttachmentsViewerComponent } from './components/view-files/components/attachments-viewver/attachments-viewver.component';
import { AttachmentsViewerCoreComponent } from './components/view-files/components/attachments-viewver/attachments-viewver-core/attachments-viewver-core.component';
import { EmptyValuePipe } from './pipes/empty-value.pipe';
import { EmptyDashPipe } from './pipes/empty.pipe';

export const CustomCurrencyMaskConfig: CurrencyMaskConfig = {
	align: 'right',
	allowNegative: true,
	decimal: ',',
	precision: 2,
	prefix: '',
	suffix: '',
	thousands: '.'
};

export function httpAuthFactory(
	backend: XHRBackend,
	defaultOptions: RequestOptions,
	location: Location,
	loginService: LoginRequestService,
	router: Router,
	appConfig: AppConfigEnvironmentService,
	commoditiesUtilityService:CommoditiesUtilityService
): HttpAuthService {
	return new HttpAuthService(
		backend,
		defaultOptions,
		location,
		loginService,
		router,
		appConfig,
		commoditiesUtilityService
	);
}

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		HttpModule,
		CountoModule,
		RouterModule,
		MatBadgeModule,
		MatIconModule,
		MatSidenavModule,
		MatTabsModule,
		MatSlideToggleModule,
		MatButtonModule,
		MatGridListModule,
		MatSelectModule,
		MatInputModule,
		MatRadioModule,
		MatCheckboxModule,
		MatChipsModule,
		MatCardModule,
		MatDialogModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatTooltipModule,
		MatProgressBarModule,
		MatExpansionModule,
		MatListModule,
		MatToolbarModule,
		MatAutocompleteModule,
		MatBottomSheetModule,
		MatStepperModule,
		MatMenuModule,
		MatDatepickerModule,
		MatNativeDateModule,
		NgxPaginationModule,

		DpDatePickerModule,

		DeviceDetectorModule.forRoot(),
		CountoModule,
		CurrencyMaskModule,
		InternalImpactPointModule,
		QuillModule,
	],
	declarations: [
		HighLightPipe,
		RemoveSpacesPipe,
		NumberFormatPipe,
		SafeHtmlPipe,
		DateUtcPipe,
		DateUtcPipeLocale,
		DateCustomFormat,
		DateOffsetUtcPipe,
		DateCustomFormatPipe,
		FileSizePipe,
		CapitalizeFirstLetterPipe,
		SpaceDumperPipe,
		TimeFromNowPipe,
		TranslatePipe,
		SuffixPipe,
		PrefixPipe,
		BreadcrumbComponent,
		GeneralMessageDialogComponent,
		HeaderComponent,
		SelectCenterComponent,
		SelectCenterLocalComponent,
		InnerMessagesComponent,
		AmdStickyComponent,
		DragAndDropFileComponent,
		SearchDialogComponent,
		AddToHomeDialogComponent,
		ErrorPageComponent,
		RemoveFileDialogComponent,
		AutoCompleteComponent,
		CardComponent,
		ToolbarWidgetComponent,
		AlertsWidgetComponent,
		SimpleTableComponent,
		FormAccordionContainerComponent,
		PaginatorComponent,
		AddAttachedDialogComponent,
		FullScreenSimpleTableDialogComponent,
		AmdStepperComponent,
		TagItemComponent,
		NotificationItemComponent,
		PaginatorComponent,
		DownloadListComponent,
		AddAttachedDialogComponent,
		ItemsCounterComponent,
		InfiniteScrollerDirective,
		ChipsComponent,
		HeaderDetailsComponent,
		NotFoundPageComponent,
		CalendarHeaderComponent,
		PrintButtonComponent,
		PdfViewerComponent,
		CcSelectDataForAppointmentTableComponent,
		AttachFileComponent,
		IncludeTemplateComponent,
		FindCenterComponent,
		FindCentersComponent,
		SelectCheckAllComponent,
		CcSelectCenterForAppointmentComponent,
		CcCenterListForAppointmentComponent,
		GenericViewAttachmentsComponent,
		GenericViewAttachmentItemComponent,
		GenericViewAttachmentPreviewDialogComponent,
		GenericViewAttachmentUploadComponent,
		ReportButtonComponent,
		InPageMessageComponent,
		TyresMatChipStatusComponent,
		TireImpactPointComponent,
		ExternalImpactPointComponent,
		MaxNumberGrantedDirective,
		MatDatepickerValidDateDirective,
		MatSelectResponsivePanelDirective,
		KeysPipe,
		VersionComponent,
		CoreSignComponent,
		SignStepperComponent,
		FormattedNumberPipe,
		MultiCurrencyPipe,
		TyresMatChipStatusComponent,
		WarningDialogComponent,
		MessageManagerComponent,
		TooltipComponent,
		DialogReadonlyComponent,
		ConfirmActionDialogComponent,
		NoSpaceInputDirective,
		AdministrationPanelComponent,
		AdministrationPanelItemComponent,
		DigitalSignProcedureComponent,
		DigitalSignOperatorProcedureStartComponent,
		DigitalSignOperatorProcedureEndComponent,
		DigitalSignCustomerProcedureStartComponent,
		DigitalSignCustomerProcedureEndComponent,
		SignOptionsComponent,
		DigitalSignContentFileDialogComponent,
		DigitalSignOtpDialogComponent,
		PaperSignMotivationDialogComponent,
		CoreSignAttachmentComponent,
		BookingCalendarComponent,
		NotificationDialogComponent,
		DateIntervalPipe,
		GeneralNotesComponent,
		GeneralNoteDialogComponent,
		GeneralStepperComponent,
		ConfirmActionComponent,
		TableListButtonHeader,
		CenterListSelectComponent,
		AttachmentsViewerComponent,
		AttachmentsViewerCoreComponent,
		EmptyValuePipe,
		CenterListSelectComponent,		
		AttachmentsViewerComponent,
		AttachmentsViewerCoreComponent,
		EmptyDashPipe
	],
	exports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		HttpModule,
		RouterModule,
		CountoModule,
		NgxPaginationModule,
		MatBottomSheetModule,
		MatBadgeModule,
		MatIconModule,
		MatSidenavModule,
		MatTabsModule,
		MatSlideToggleModule,
		MatButtonModule,
		MatGridListModule,
		MatSelectModule,
		MatInputModule,
		MatRadioModule,
		MatCheckboxModule,
		MatChipsModule,
		MatCardModule,
		MatDialogModule,
		MatProgressSpinnerModule,
		MatSnackBarModule,
		MatTooltipModule,
		MatProgressBarModule,
		MatExpansionModule,
		MatListModule,
		MatToolbarModule,
		MatAutocompleteModule,
		MatMenuModule,
		MatStepperModule,
		MatDatepickerModule,
		MatNativeDateModule,
		NgxPaginationModule,
		DpDatePickerModule,
		DeviceDetectorModule,
		CountoModule,
		InternalImpactPointModule,
		DateUtcPipeLocale,
		DateCustomFormat,
		DateOffsetUtcPipe,
		HighLightPipe,
		RemoveSpacesPipe,
		NumberFormatPipe,
		SafeHtmlPipe,
		DateUtcPipe,
		TimeFromNowPipe,
		DateCustomFormatPipe,
		FileSizePipe,
		CapitalizeFirstLetterPipe,
		SpaceDumperPipe,
		TranslatePipe,
		SuffixPipe,
		PrefixPipe,
		BreadcrumbComponent,
		GeneralMessageDialogComponent,
		HeaderComponent,
		SelectCenterComponent,
		SelectCenterLocalComponent,
		InnerMessagesComponent,
		AmdStickyComponent,
		DragAndDropFileComponent,
		SearchDialogComponent,
		ErrorPageComponent,
		AutoCompleteComponent,
		TagItemComponent,
		ChipsComponent,
		NotificationItemComponent,
		PaginatorComponent,
		DownloadListComponent,
		ItemsCounterComponent,
		AddAttachedDialogComponent,
		InfiniteScrollerDirective,
		CardComponent,
		ToolbarWidgetComponent,
		AlertsWidgetComponent,
		SimpleTableComponent,
		AddAttachedDialogComponent,
		PaginatorComponent,
		AmdStepperComponent,
		NotFoundPageComponent,
		HeaderDetailsComponent,
		CalendarHeaderComponent,
		PrintButtonComponent,
		FormAccordionContainerComponent,
		PdfViewerComponent,
		CurrencyMaskModule,
		CcSelectDataForAppointmentTableComponent,
		AttachFileComponent,
		IncludeTemplateComponent,
		FindCenterComponent,
		FindCentersComponent,
		SelectCheckAllComponent,
		CcSelectCenterForAppointmentComponent,
		CcCenterListForAppointmentComponent,
		GenericViewAttachmentsComponent,
		ReportButtonComponent,
		InPageMessageComponent,
		GenericViewAttachmentPreviewDialogComponent,
		GenericViewAttachmentItemComponent,
		GenericViewAttachmentUploadComponent,
		TireImpactPointComponent,
		TyresMatChipStatusComponent,
		ExternalImpactPointComponent,
		MaxNumberGrantedDirective,
		MatDatepickerValidDateDirective,
		MatSelectResponsivePanelDirective,
		KeysPipe,
		CoreSignComponent,
		FormattedNumberPipe,
		MultiCurrencyPipe,
		TyresMatChipStatusComponent,
		WarningDialogComponent,
		MessageManagerComponent,
		TooltipComponent,
		DialogReadonlyComponent,
		ConfirmActionDialogComponent,
		NoSpaceInputDirective,
		BookingCalendarComponent,
		DateIntervalPipe,
		GeneralNotesComponent,
		ConfirmActionComponent,
		TableListButtonHeader,
		GeneralStepperComponent,
		CenterListSelectComponent,
		AttachmentsViewerComponent,
		AttachmentsViewerCoreComponent,
		EmptyValuePipe,
		EmptyDashPipe
	],
	entryComponents: [
		GeneralMessageDialogComponent,
		SearchDialogComponent,
		AddToHomeDialogComponent,
		RemoveFileDialogComponent,
		FullScreenSimpleTableDialogComponent,
		AddAttachedDialogComponent,
		GenericViewAttachmentPreviewDialogComponent,
		WarningDialogComponent,
		ConfirmActionDialogComponent,
		DigitalSignOtpDialogComponent,
		CalendarHeaderComponent,
		DigitalSignContentFileDialogComponent,
		PaperSignMotivationDialogComponent,
		NotificationDialogComponent,
		GeneralNoteDialogComponent,
		ConfirmActionComponent,
		DialogReadonlyComponent
	],
	providers: [
		//{provide: MD_RIPPLE_GLOBAL_OPTIONS, useValue: {disabled: true}},
		//{provide: MD_ERROR_GLOBAL_OPTIONS, useValue: {errorStateMatcher: ShowOnDirtyErrorStateMatcher}},
		{provide: MAT_DATE_LOCALE, useValue: 'it'},
		{
			provide: DateAdapter,
			useClass: MomentDateAdapter,
			deps: [MAT_DATE_LOCALE]
		},
		{provide: MAT_DATE_FORMATS, useValue: APP_MOMENT_DATE_FORMATS},
		{provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig},
		MultiCurrencyPipe
	]
})
export class SharedModule {
}
